import { Button, Checkbox, Icon, Modal, Snackbar } from "@mui/material";
import "../../../theme/global.css"
import "../login/login.css"
import { AppInput } from "../../../components/Input";
import { ErrorConsts } from "../../../utils/ErrorCons";
import { ComponentState, useEffect, useState } from "react";
import { Navigate, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loginAction, saveAuthError, saveForgotPasswordResponse } from "../../../redux/actions";
import { routes } from "../../../navigation/appRoutes";
import { AppButtons } from "../../../components/button";
import localKey from "../../../storage/localKey";
import { ForgotPassword } from "./forgot-password";
import CustomSnackbar from "../../../components/snackbar";
import { ChangePassword } from "./change-password";

export const Login = () => {
  let token = localStorage.getItem(localKey.AUTH_TOKEN);

  const [buttonPressed, setButtonPressed] = useState(false)
  const [email, setEmail] = useState<string>()
  const [isUserParent, setUserParent] = useState(false)
  const [password, setPassword] = useState<string>()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const state: ComponentState = useSelector(states => {
    return states;
  });
  const { loadingState } = state['LoaderReducer'];
  const { errorMeesage, authResponse } = state['AuthReducer'];
  const [openForgotPassword, setOpenForgotPassword] = useState<boolean>(false)
  const [isOpenChangePassword, setIsOpenChangePassword] = useState(false)
  const [passwordType,setPasswordType]=useState("password");


  useEffect(() => {
    if (authResponse?.isTempPassword) {
      setIsOpenChangePassword(true)
    }
    else if (authResponse?.token !== undefined || "" || null) {
      navigate(routes.home, { replace: true })
    }
  }, [authResponse])


  const handleButtonPressed = () => {
    setButtonPressed(true)
    if (email && email.length > 0 && password && password.length > 0) {
      dispatch(saveAuthError())
      dispatch(loginAction({ userName: email, password: password, isParentLogin: isUserParent }))
    }
  }

  const handleForgetPassword = () => {
    dispatch(saveForgotPasswordResponse(""))
    setOpenForgotPassword(!openForgotPassword)
  }

  const handleChangePassword = () => {
		setIsOpenChangePassword(!isOpenChangePassword)
	}

  const togglePassword =(event: any)=>{
    event.preventDefault();
 
     if(passwordType==="password")
     {
      setPasswordType("text")
      return;
     }
     setPasswordType("password")
   }

  useEffect(() => {
    if(localStorage) {
      localStorage.clear()
    }
  }, [])

  return <>
    <section className="login-wrapper">
      <Modal
        open={openForgotPassword}
        onClose={() => { }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div>
          <ForgotPassword onClose={handleForgetPassword} title={"Forgot Password"} />
        </div>
      </Modal>

      <Modal
        open={isOpenChangePassword}
        onClose={() => { }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div>
          <ChangePassword onClose={handleChangePassword} title={"Change Password"} subtitle={'You must have to setup new password to continue...'}/>
        </div>
      </Modal>
      <div className="container">
        <div className="login-box">
          <div className="col-md-8 mx-auto col-sm-10 col-12">
            <p className="text-center grayText f-13 fw-600 maxWidth mb-3">With Client Portal, you can connect with your staff through a convenient, safe and secure environment.
            </p>
            <div className="login-div my-3">
              <h2 className="mb-3 fw-600">Log into Client Portal
              </h2>
              <form>
                <AppInput labelText="Username"
                  placeHolder="Username"
                  showError={buttonPressed && (!email || email.length < 1)}
                  errorMessage={ErrorConsts.USERNAME}
                  onChange={setEmail}></AppInput>

                <div className="mb-2 position-relative">

                <AppInput labelText="Password"
                  placeHolder="Enter Password"
                  inputType={passwordType}
                  showError={buttonPressed && (!password || password.length < 1)}
                  errorMessage={ErrorConsts.Password}
                  onChange={setPassword}></AppInput>
                  <span className="password-hide-show-icon" onClick={togglePassword}>
                     { passwordType==="password"? <i className="fa fa-eye" aria-hidden="true"></i>:<i className="fa fa-eye-slash" aria-hidden="true"></i>}
                     </span>
                  </div>

                <div className="form-group">
                  <Checkbox
                    onChange={(event) => {
                      setUserParent(event.target.checked)
                    }} />
                  <label className="fw-500" >{'Log in as Guardian?'}</label>
                </div>

                <div className="cursor-pointer my-2"><p className="f14 fw-500 greenText " style={{ cursor: "pointer" }} onClick={handleForgetPassword}>Forgot Password? </p></div>

                <AppButtons buttonText="Submit" onclick={handleButtonPressed} loadingState={loadingState}></AppButtons>

                {(errorMeesage && errorMeesage != null) &&

                  <p className="mb-3 mt-2 fw-600 error-message text-left m-0 f-14 fw-400 mb-0"> {errorMeesage} </p>

                }

              </form>
            </div>
          </div>
        </div>
      </div>


    </section>

  </>
}